<div class="comment-box">
  @if (canEdit) {
    <h3>Kommentare
      <span class="clickable text-primary" (click)="openBox()">
        <i class="fa fa-plus click"></i>
      </span>
    </h3>
  }

  @if (box && canEdit) {
    <form class="new-task-comment" [formGroup]="createForm" (ngSubmit)="create()">
      <label>
        <textarea rows="3" class="form-control input-sm" formControlName="text"
          placeholder="Kommentar hinzufügen" autofocus="autofocus">
        </textarea>
        <button class="btn btn-sm btn-success" type="submit" style="margin-top: 5px;">
          Hinzufügen
        </button>
      </label>
    </form>
  }

  <div class="whitelist commentlist">
    @for (comment of list.objects; track comment; let index = $index) {
      <div class="whitelist-item whitelist-item-no-cursor" [ngClass]="commentClasses(comment)">
        <div class="whitelist-detail">
          @if (comment.additional) {
            <div class="whitelist-item-detail-first">
              <strong>{{ comment.additional.headline }}</strong>
            </div>
          }
          <div class="whitelist-item-detail-first">
            <div class="pull-left">
              <strong>{{ comment.date | date:'dd.MM.yyyy HH:mm' }} - {{ comment.username }}</strong>
            </div>
            @if (canBeMarked(comment)) {
              <div class="pull-right ml-2">
                <button type="button" class="ev-button" (click)="mark(index, comment)">
                  <i class="fa fa-flag" aria-hidden="true"></i>
                </button>
              </div>
            }
            @if (isArticleOrWorkflow) {
              <div class="pull-right">
                <button type="button" class="ev-button" (click)="remove(index, comment)">
                  <i class="fa fa-trash-o"></i>
                </button>
              </div>
            }
          </div>
        </div>
        <div class="clear-both"></div>
        <!-- DO NOT WRAP: comment.text -->
        @if (comment.typ !== 'label_print' && !comment.additional?.json && !comment.additional?.html) {
          <div class="whitelist-item-detail-second"
            >
            {{ comment.text }}
          </div>
        }
        @if (comment.typ !== 'label_print' && !!comment.additional?.html) {
          <div class="whitelist-item-detail"
            [innerHTML]="comment.text"
            >
          </div>
        }
        @if (comment.typ === 'material_order') {
          <comment-material-order [comment]="comment"
            [add]="comment.additional"
            >
          </comment-material-order>
        }
      </div>
    }
    <ev-navigation [page]="list.page" [pages]="list.pages" [query]="query()" (goto)="goto($event)"></ev-navigation>
  </div>
</div>
